<button class="flex flex-middle flex-justify-center b-radius-max fashion-slide--card">
  <div class="ratio-1-1 fashion-slide--image">
    <img class="rf z-1"
      [class.is-base]="slideData.slideImageHover"
      [image]="slideData.slideImage">

    @if (slideData.slideImageHover) {
      <img class="rf z-2 pe-none on-hover"
        [image]="slideData.slideImageHover"
        >
    }
  </div>
</button>

<p class="h4 col-1 m-t-5">{{ slideData.slideTitle }}</p>

<button class="inline-flex flex-middle flex-justify-center m-t-5 button-colours"
  (click)="select()">
  <i class="icon-colours"></i>
  <span class="m-l-2 p2">{{'View Colours' | translate}}</span>
</button>